module.exports = __webpack_public_path__ + "img/search.c3af7df1.png";